export const homeFaqs = [
  {
    q: 'Who provides hardwood flooring services near me in Maryland?',
    a: 'Premier Hardwood Floors provides professional hardwood installation, refinishing, and repair services throughout Maryland. Serving residential homeowners across Baltimore, Annapolis, Columbia, Silver Spring, Rockville, and surrounding areas with expert craftsmanship and transparent pricing.',
  },
  {
    q: 'How much does hardwood floor refinishing cost in Maryland?',
    a: 'Hardwood floor refinishing costs vary by floor condition, square footage, and finish type. Most Maryland homeowners pay between $3–$8 per square foot. Premier Hardwood Floors provides free in-home estimates with itemized, transparent quotes and no hidden fees.',
  },
  {
    q: 'How long does hardwood floor installation take?',
    a: 'Most residential hardwood floor installations take 3–7 days, including subfloor preparation, installation, staining, and finishing. Project timelines vary by square footage and complexity. We provide a precise schedule during your free in-home estimate.',
  },
  {
    q: 'Is it better to refinish or replace hardwood floors?',
    a: 'Refinishing is typically more cost-effective when floors are structurally sound with surface-level wear. Replacement is better for severely damaged, thin, or structurally compromised floors. Premier Hardwood Floors assesses your specific situation during a free in-home consultation.',
  },
  {
    q: 'How much does hardwood floor repair cost in Maryland?',
    a: 'Hardwood floor repair costs depend on the type and extent of damage. Minor repairs such as scratches or small gaps start at a few hundred dollars, while water damage or board replacement varies by scope. We provide a full assessment and written quote at no charge.',
  },
  {
    q: 'What is the best hardwood flooring for Maryland homes?',
    a: 'White oak and red oak are top choices for Maryland homes due to their durability and dimensional stability in the region\'s humidity. Hickory and maple offer excellent wear resistance. Our specialists recommend the ideal species and finish for your specific home and lifestyle.',
  },
  {
    q: 'Do you offer free estimates for hardwood flooring in Maryland?',
    a: 'Yes. Premier Hardwood Floors provides free, no-obligation in-home estimates throughout Maryland. Our specialists assess your space, evaluate floor condition, and deliver a detailed written quote so you can make a confident, informed decision.',
  },
  {
    q: 'How long does hardwood floor refinishing last?',
    a: 'Professionally refinished hardwood floors typically last 8–15 years before needing refinishing again, depending on traffic, maintenance, and finish type. Solid hardwood can be refinished 5–10 times over its lifetime, making it an exceptional long-term investment.',
  },
];

export const locationFaqs = (city: string) => [
  {
    q: `Who provides hardwood flooring services near me in ${city}?`,
    a: `Premier Hardwood Floors provides professional hardwood installation, refinishing, and repair services in ${city}, Maryland. They specialize in residential properties, delivering expert craftsmanship tailored to ${city}'s diverse architectural styles and homeowners' needs.`,
  },
  {
    q: `How much does hardwood floor installation cost in ${city}, Maryland?`,
    a: `Hardwood floor installation costs in ${city} vary by square footage, wood species, and project complexity. Premier Hardwood Floors provides free in-home estimates with detailed, transparent quotes — no hidden fees, no surprises. Contact us to schedule your free assessment.`,
  },
  {
    q: `How quickly can you start a hardwood flooring project in ${city}?`,
    a: `Most ${city} projects begin within 1–2 weeks after the estimate and scheduling process is complete. We work around your schedule and communicate clearly throughout to minimize disruption to your daily routine.`,
  },
  {
    q: `What types of hardwood flooring work best in ${city} homes?`,
    a: `Maryland's humidity and seasonal temperature shifts make dimensional stability important. White oak, red oak, and quality engineered hardwood are all excellent choices for ${city} homes. Our specialists recommend the ideal option based on your specific floors, traffic, and lifestyle during a free consultation.`,
  },
  {
    q: `Do you repair water-damaged hardwood floors in ${city}?`,
    a: `Yes. Premier Hardwood Floors repairs water-damaged hardwood floors throughout ${city}, Maryland. Many water-damaged floors can be restored through drying, sanding, and refinishing. Severe structural damage may require board replacement. We assess every case individually at no charge.`,
  },
];
